import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[6]};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  flex-wrap: wrap;
`;

export const TitleText = styled.h2`
  margin: 0;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size.xl};
  line-height: 1.2;
  color: ${semantic.text.primary};
  flex: 1;
  min-width: 0;
`;

export const ConfirmationRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[2]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const ConfirmationCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[4]};
  height: ${space[4]};
  border-radius: ${layout.borderRadiusFull};
  background: ${semantic.bg.positiveStrong};
  color: ${colors.white};
`;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[5]};

  > * + * {
    border-top: 1px solid ${semantic.border.default};
    padding-top: ${space[5]};
  }
`;

export const TotalRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const TotalLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-family: ${fonts.body};
`;

export const TotalLabel = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
`;

export const SummaryLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-family: ${fonts.body};
`;

export const SummaryLabel = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const DiscountAmount = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.positive};
`;
